import { safecheckFr } from "./safecheck/fr";

export const fr: Translations = {
  nav: {
    dashboards: "Tableaux de bord",
    ecommerce: "eCommerce",
    analytics: "Analytique",
    crm: "CRM",
    landing: "Page d'atterrissage",
  },
  header: {
    menu: "Menu",
    closeSidebar: "Réduire le menu",
    grid: "Grille",
    search: "Rechercher",
    messages: "Messages",
    notifications: "Notifications",
    language: "Changer la langue",
    settings: "Paramètres",
    profile: "Profil",
    logout: "Se déconnecter",
    changeSession: "Changer de session",
    sessionActive: "Session active",
    userNames: {
      admin: "Elvis KATUALA",
      auditor: "Guystave MONYAWANGERE",
    },
  },
  shell: {
    emergencyHelp: "Aide d'urgence",
    promoTitle: "Prendre un rendez-vous",
    promoSubtitle: "Les meilleurs soins de santé ici",
    promoCta: "En savoir plus",
    fullscreen: "Plein écran",
  },
  search: {
    placeholder: "Rechercher une page, une action...",
    noResults: "Aucun résultat Safecheck",
    pages: "Page",
    widgets: "Raccourci",
    actions: "Action",
    indicators: "Indicateur",
    shortcut: "⌘K",
  },
  settings: {
    title: "Paramètres",
    appearance: "Apparence",
    theme: "Choisissez votre thème",
    themeLight: "Clair",
    themeDark: "Sombre",
    themeSystem: "Système",
    language: "Langue",
    languageDescription: "Sélectionnez votre langue préférée",
    layout: "Mise en page",
    sidebarExpanded: "Barre latérale étendue",
    close: "Fermer les paramètres",
  },
  safecheck: safecheckFr,
  actions: {
    saved: "Enregistrement réussi.",
    exported: "Export terminé.",
    deleted: "Suppression effectuée.",
    printed: "Impression lancée.",
  },
  common: {
    orders: "Commandes",
    expenses: "Dépenses",
    clicks: "clics",
    winner: "Gagnant",
    visitors: "Visiteurs",
    conversions: "Conversions",
    bounce: "Rebond",
    sales: "ventes",
    options: "Options",
    order: "Commande",
    customer: "Client",
    product: "Produit",
    amount: "Montant",
    status: "Statut",
    balance: "Solde",
    cardNumber: "Numéro de carte",
    lastMonth: "le mois dernier",
    last12Months: "les 12 derniers mois",
    january: "janvier",
    completed: "Terminée",
    pending: "En attente",
    shipped: "Expédiée",
    devices: { Desktop: "Bureau", Mobile: "Mobile", Tablet: "Tablette" },
    months: {
      Jan: "Jan", Feb: "Fév", Mar: "Mar", Apr: "Avr", May: "Mai", Jun: "Juin", July: "Juil",
      JAN: "JAN", FEB: "FÉV", MAR: "MAR", APR: "AVR", MAY: "MAI", JUN: "JUIN",
      W1: "S1", W2: "S2", W3: "S3", W4: "S4", W5: "S5", W6: "S6",
      Mon: "Lun", Tue: "Mar", Wed: "Mer", Thu: "Jeu", Fri: "Ven", Sat: "Sam", Sun: "Dim",
    },
    categories: {
      Electronics: "Électronique",
      Accessories: "Accessoires",
      Clothing: "Vêtements",
      Other: "Autre",
    },
    sources: {
      Organic: "Organique",
      Direct: "Direct",
      Social: "Social",
      Referral: "Référence",
    },
  },
  crm: {
    pageTitle: "Tableau de bord CRM",
    pageDescription: "Vue d'ensemble de la gestion de la relation client",
    overallBalance: "Solde global",
    trend: "+16,3 % sur les 12 derniers mois",
    totalSales: "Ventes totales",
    totalProfit: "Profit total",
    totalUsers: "Utilisateurs totaux",
    totalExpense: "Dépenses totales",
    roi: "Retour sur investissement",
    roiValue: "283 % ROI",
    monthlyChange: "+24 % en janvier",
    totalFollowers: "Abonnés totaux",
    totalIncome: "Revenu total",
    currentBalance: "Solde actuel",
    changeFollowers: "+23 % le mois dernier",
    changeIncome: "+18 % le mois dernier",
    changeBalance: "+42 % le mois dernier",
    marketingReport: "Rapport marketing",
    searchVolume: "Volume de recherche",
    returnRatio: "Taux de retour",
    paymentMethods: "Moyens de paiement",
  },
  ecommerce: {
    pageTitle: "Tableau de bord eCommerce",
    pageDescription: "Vue d'ensemble des ventes, produits et commandes",
    revenueOverview: "Aperçu des revenus",
    topProducts: "Meilleurs produits",
    salesByCategory: "Ventes par catégorie",
    recentOrders: "Commandes récentes",
    stats: {
      orders: "Commandes totales",
      revenue: "Revenus",
      customers: "Clients",
      returns: "Retours",
    },
  },
  analytics: {
    pageTitle: "Tableau de bord Analytique",
    pageDescription: "Trafic web et comportement des utilisateurs",
    trafficOverview: "Aperçu du trafic",
    trafficSources: "Sources de trafic",
    topPages: "Pages populaires",
    deviceBreakdown: "Répartition par appareil",
    stats: {
      visitors: "Visiteurs",
      pageviews: "Pages vues",
      bounce: "Taux de rebond",
      duration: "Durée moyenne",
    },
  },
  landing: {
    pageTitle: "Tableau de bord Landing",
    pageDescription: "Performance et conversions de la page d'atterrissage",
    signupsConversions: "Inscriptions et conversions",
    ctaPerformance: "Performance des CTA",
    abTestResults: "Résultats des tests A/B",
    stats: {
      visitors: "Visiteurs landing",
      signups: "Inscriptions",
      conversion: "Taux de conversion",
      cta: "Clics CTA",
    },
    ctas: {
      getStarted: "Commencer gratuitement",
      watchDemo: "Voir la démo",
      contactSales: "Contacter les ventes",
      downloadPdf: "Télécharger le PDF",
    },
    variants: {
      variantA: "Variante A — CTA bleu",
      variantB: "Variante B — CTA vert",
    },
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Tout marquer comme lu",
    clearAll: "Tout effacer",
    empty: "Aucune notification",
    delete: "Supprimer la notification",
    justNow: "À l'instant",
    minutesAgo: "Il y a {{n}} min",
    hoursAgo: "Il y a {{n}}h",
    yesterday: "Hier",
    items: {
      newAdmission: {
        title: "Nouvelle admission",
        message: "Patient Mwamba K. admis à l'hôpital Medecin de nuit — CEEC",
      },
      invoicesPendingReview: {
        title: "Factures en attente",
        message: "3 factures soumises nécessitent une validation (FAC-2026-022, 021, 020)",
      },
      urgentAuthorization: {
        title: "Autorisation urgente",
        message: "Demande #1247 — chirurgie cardiaque, priorité haute",
      },
      invoiceApproved: {
        title: "Facture approuvée",
        message: "FAC-2026-019 validée pour Medecin de nuit — 15 600 USD",
      },
      conventionExpiring: {
        title: "Convention à échéance",
        message: "La convention CONV-03 avec CEEC expire dans 15 jours",
      },
      newProviderRegistered: {
        title: "Nouveau prestataire",
        message: "Clinique Mwangeji enregistrée dans le réseau Safecheck",
      },
      systemBackupComplete: {
        title: "Sauvegarde terminée",
        message: "Sauvegarde automatique du système effectuée avec succès",
      },
      newEmployeeRegistered: {
        title: "Nouvel assuré",
        message: "Katanga M. ajouté comme bénéficiaire — entreprise CEEC",
      },
    },
  },
};
